export const formatDateLong = (dateRaw) => {
    if (dateRaw) {
        const newDate = new Date(dateRaw).toLocaleString("nl-NL", {
            weekday: "long",
            day: "numeric",
            month: "numeric",
            year: "numeric"
        });
        return newDate;
    } else {
        return "";
    }
}

export const formatDateShort = (dateRaw) => {
    if (dateRaw) {
        const newDate = new Date(dateRaw).toLocaleString("nl-NL", {
            // weekday: "long",
            day: "numeric",
            month: "numeric",
            year: "numeric"
        });
        return newDate;
    } else {
        return "";
    }
}

export const stringToDate = (dateString) => {
    if (dateString) {
        const newDate = new Date(dateString);
        return newDate;
    } else {
        return "";
    }
}


export const formatDateForForm = (dateRaw) => {
    if (dateRaw) {
        const newDate = new Date(dateRaw).toLocaleString("en-CA", {
            year: "numeric",
            month: "numeric",
            day: "numeric"
            
        });
        return newDate;
    } else {
        return "";
    }
}

export const fullName = (personObject) => {
    
    const { voornaam = "", tussenvoegsel = "", achternaam = "" } = personObject;
    if (!voornaam && !achternaam) {
        return "--";
    }

    const name = tussenvoegsel ? `${voornaam} ${tussenvoegsel} ${achternaam}` : `${voornaam} ${achternaam}`;
    return name;    
}

export const sortActiviteitenByDate = (activiteitenArray) => {
     const sortedActiviteiten = activiteitenArray.sort((d1, d2) => new Date(d1.datum).getTime() - new Date(d2.datum).getTime()); 
     return (sortedActiviteiten ? sortedActiviteiten : [] );
}